$b.on('click', '.hf-modal-trigger', function(e){
  e.preventDefault();
  $b.addClass('hf-modal-shown');
});

/*
  Results page
*/
const workingTime = 350;
function enableWorking(){
  $('#results').addClass('working');
}
function disableWorking(){
  $('#results').removeClass('working');
}
function itemMarkup(item){
  return `<div class="col-md-4 col-xl-3 hf-hit"
    data-name="${item.name}"
    data-price="${item.price}"
    data-carry_type="${item.carry_type}"
    data-color="${item.color}"
    data-finish="${item.finish}"
    data-material="${item.material}"
    data-holster_ride="${item.holster_ride}"
    data-holster_type="${item.holster_type}"
    data-retention_level="${item.retention_level}"
    data-security_mechanism="${item.security_mechanism}"
    data-function="${item.function}"
    data-series="${item.series}"
    >
    <a href="/products/${item.url}" class="card is-type-product">
      <div class="media" tabindex="-1">
        <div class="image"><img src="${item.thumbnail}" alt="" loading="lazy" width="345" height="517" /></div>
      </div>
      <div class="information">
        <h3 class="title h4">${item.name}</h3>
        <div class="price">
          ${$('#price-template').text().replaceAll('{price}', '$' + item.price)}
        </div>
      </div>
    </a>
  </div>`;
}

function getData(){
  return JSON.parse($('#holster-finder-results-json').text());
}

function populateItems(items){
  $('#product-grid-items').html('');
  items.forEach(item => {
    $('#product-grid-items').append(itemMarkup(item));
  });
}

function populateGunDetails(data){
  let $target = $('#firearm-details');
  if ($target.length == 0) {
    return;
  }

  let firearm = data.gun.manufacturer + ' ' + data.gun.model;

  if (data.gun.barrel || data.gun.caliber) {
      let bc = [];
      if (data.gun.barrel) {
          bc.push(data.gun.barrel + ' Barrel Length');
      }
      if (data.gun.caliber) {
          bc.push(data.gun.caliber + ' Caliber');
      }
      firearm += '<br />(' + bc.join(', ') + ')';
  }
  let items = [
    {
      "key" : "Firearm",
      "value" : firearm
    },
    {
      "key" : "Light",
      "value" : data.details.lightName
    },
    {
      "key" : "Optic",
      "value" : data.details.opticName
    },
    {
      "key" : "Carry",
      "value" : data.carryMethod
    }
  ];

  $target.html('');
  items.forEach(item => {
    if (item.value) {
      $target.append(`<div><dt>${item.key}</dt><dd>${item.value}</dd></div>`);
    }
  });
}

function calculateFilters(holsters, key){
  let result = holsters.map(function (holster) {
      return holster[key];
  }).sort().filter((x, i, a) => x && (!i || x != a[i-1]));
  return result;
}

function populateFilters(data){
  let holsters = data.gun.holsters;
  if (!holsters) {
    return false;
  }

  let filters = [];

  filters.push({
    "label" : "Type",
    "key" : "holster_type",
    "items" : calculateFilters(holsters, 'holster_type')
  });
  filters.push({
    "label" : "Carry Method",
    "key" : "carry_type",
    "items" : calculateFilters(holsters, 'carry_type')
  });
  filters.push({
    "label" : "Function",
    "key" : "function",
    "items" : calculateFilters(holsters, 'function')
  });
  filters.push({
    "label" : "Ride",
    "key" : "holster_ride",
    "items" : calculateFilters(holsters, 'holster_ride')
  });
  filters.push({
    "label" : "Series",
    "key" : "series",
    "items" : calculateFilters(holsters, 'series')
  });
  filters.push({
    "label" : "Retention Level",
    "key" : "retention_level",
    "items" : calculateFilters(holsters, 'retention_level')
  });
  filters.push({
    "label" : "Security Mechanism",
    "key" : "security_mechanism",
    "items" : calculateFilters(holsters, 'security_mechanism')
  });
  filters.push({
    "label" : "Material",
    "key" : "material",
    "items" : calculateFilters(holsters, 'material')
  });
  filters.push({
    "label" : "Finish",
    "key" : "finish",
    "items" : calculateFilters(holsters, 'finish')
  });
  filters.push({
    "label" : "Color",
    "key" : "color",
    "items" : calculateFilters(holsters, 'color')
  });

  $('#hf-filters').html('');

  let haveFilters = false;
  filters.forEach(filterGroup => {
    // bail on groups without choices
    if (filterGroup.items.length < 2) return;
    // markup added in the main-holster-finder.liquid to use a snippet
    let groupMarkup = $('#filter-template').text();
    // add the panel title
    groupMarkup = groupMarkup.replace('{panelTitle}', filterGroup.label);
    // add the panel items
    let choices = '<ul class="checkboxes">';
    filterGroup.items.forEach(item => {
      choices += `<li><a href="#" data-key="${filterGroup.key}">${item}</a></li>`;
    });
    choices += '</ul>';
    groupMarkup = groupMarkup.replace('{panelContent}', choices);
    // do it
    $('#hf-filters').append(groupMarkup);
    haveFilters = true;
  });

  return haveFilters;
}

function updateNotFoundMessage(behavior, selector){
  let $haveResultsEls = $('#product-grid-items, .sorting');
  if (behavior === 'show') {
    $haveResultsEls.hide();
    $(selector).show();
  } else {
    $haveResultsEls.show();
    $(selector).hide();
  }
}

function buildFilteredResults(){
  // rebuild active filters
  $('#active-filters').html('');
  $('.hf-hit').removeClass('.d-none');
  let $activeFilters = $('#hf-filters li.selected');
  let selector = [];
  if ($activeFilters.length) {
    $('#active-filters').append('<div class="items"><a href="#" id="clear-filters">Clear All</a></div>');
    $activeFilters.each(function(){
      $('#active-filters .items').prepend($(this).html());
      let k = $(this).find('a').data('key');
      let v = $(this).find('a').text();
      selector.push(`[data-${k}="${v}"]`);
    });
    // hide all, then show the items that match these filters
    $('.hf-hit').addClass('d-none');
    $(`.hf-hit${selector.join('')}`).removeClass('d-none');
    // if everything is hidden, show a message
    if ($('.hf-hit').length === $('.hf-hit.d-none').length) {
      updateNotFoundMessage('show', '#hf-no-filtered-results');
    } else {
      updateNotFoundMessage('hide', '#hf-no-filtered-results');
    }
  } else {
    // we've removed all the active filters
    $('.hf-hit').removeClass('d-none');
    updateNotFoundMessage('hide', '#hf-no-filtered-results');
    $('#hf-results').show();
    $('#hf-no-filtered-results').hide();
  }
  if ($w.width() >= window.vars.breakpoints.lg) {
    $w.scrollTop(0);
  }
}

$b.on('loaded', '#holster-finder-results-json', function(){
  let data = getData();

  // this can run before we have holster results
  if (!data.gun.hasOwnProperty('holsters')) {
    return;
  }

  let filters = populateFilters(data);

  if (filters) {
    $('#hf-filters-col').show();
  } else {
    $('#hf-filters-col').hide();
  }

  let titleHtml = `Shop by <strong>Firearm</strong>`;

  if (data.gun.holsters.length > 0) {
    let grammarize = data.gun.holsters.length === 1 ? 'Holster Fits' : 'Holsters Fit';
    titleHtml = `${data.gun.holsters.length} ${grammarize} Your <strong>Firearm</strong>`;
    populateItems(data.gun.holsters);
    updateNotFoundMessage('hide', '#hf-no-results');
  } else {
    updateNotFoundMessage('show', '#hf-no-results');
  }

  $('#hf-loading').hide();

  populateGunDetails(data);
  $('.collection-banner .title').html(titleHtml);

});

$b.on('change', '#hf-sort-by', function(){
  enableWorking();
  let $this = $(this);
  let sort = $this.val();
  let sorted = $('.hf-hit');
  if (sort === 'price-ascending') {
    sorted = sorted.sort((a, b) => {
      return $(a).data('price') - $(b).data('price');
    });
  } else if (sort === 'price-descending') {
    sorted = sorted.sort((a, b) => {
      return $(b).data('price') - $(a).data('price');
    });
  } else {
    sorted = sorted.sort((a, b) => {
      return $(a).data('name').localeCompare($(b).data('name'));
    });
  }
  // slowwing the page down some to smooth out DOM changes
  setTimeout(function(){
    $('#product-grid-items').html(sorted);
    $('.active-sort span').text($this.find(`option[value="${sort}"]`).text());
    disableWorking();
  }, workingTime);

});

$b.on('click', '#hf-filters a', function(e){
  e.preventDefault();
  let $this = $(this);
  enableWorking();
  setTimeout(function(){
    $this.closest('li').toggleClass('selected');
    buildFilteredResults();
    disableWorking();
  }, workingTime);
});

$b.on('click', '#hf-filters-col #active-filters .items a', function(e){
  e.preventDefault();
  enableWorking();
  let $this = $(this);
  setTimeout(function(){
    let $activeFilters = $('#hf-filters li.selected');
    $activeFilters.each(function(){
      if ($(this).find('a').text() === $this.text()) {
        $(this).removeClass('selected');
        buildFilteredResults();
      }
    });
    disableWorking();
  }, workingTime);
});

$b.on('click', '#hf-filters-col #clear-filters', function(e){
  e.preventDefault();
  enableWorking();
  setTimeout(function(){
    $('#hf-filters li').removeClass('selected');
    $('.hf-hit').removeClass('d-none');
    $('#active-filters').html('');
    updateNotFoundMessage('hide', '#hf-no-filtered-results');
    disableWorking();
  }, workingTime);
});

$b.on('click', '#hf-not-found-message-clear', function(e){
  e.preventDefault();
  $('#clear-filters').click();
});